import {CalendarType, QueryResult} from '@app/shared';
import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UserService } from '@app/core';

import { CommonTransformationService } from "../services/common-transformation.service";

import { CalendarEvent, CalendarParam } from './calendar';

@Injectable()
export class CalendarDataService {

  constructor (private http: HttpClient, private user: UserService, private transform: CommonTransformationService) { }

  urlWithOrgId(url, orgId): string {
    let urlWithOrgId: string = url;
    if (orgId) {
      urlWithOrgId += orgId;
    } else if (this.user.managingOrgId) {
      urlWithOrgId += this.user.managingOrgId;
    } else if (this.user.info.orgId) {
      urlWithOrgId += this.user.info.orgId;
    } else {
      console.error("cannot create urlWithOrgId");
    }

    return urlWithOrgId;
  }

  convertToCalendarParam(calendar: CalendarEvent): string {
    let param: string = "";
    if (calendar) {
      if (calendar.subtype) {
        param += `&subtype=${calendar.subtype}`;
      }
      if (calendar.start) {
        param += `&start=${calendar.start}`;
      }
      if (calendar.end) {
        param += `&end=${calendar.end}`;
      }
      if (calendar.frequency) {
        param += `&frequency=${calendar.frequency}`;
      }
      if (calendar.year) {
        param += `&year=${calendar.year}`;
      }
      if (calendar.secondStart) {
        param += `&secondStart=${calendar.secondStart}`;
      }
      if (calendar.payrollPeriodOffset) {
        param += `&payrollPeriodOffset=${calendar.payrollPeriodOffset}`;
      }
      if (calendar.startPeriodNumber) {
        param += `&startPeriodNumber=${calendar.startPeriodNumber}`;
      }

    }
    return param;
  }

  getCalendarByType(calendarType: CalendarType, year: string, orgId?: number): Observable<QueryResult> {
    if (!year) {
      year = new Date().getFullYear.toString();
    }
    let url = this.urlWithOrgId(`/solution/calendars/search/start-period-number?subtype=${calendarType}&year=${year}&orgId=`, orgId);
    return this.http.get<QueryResult>(url);
  }

  getAccountingCalendarFrequency(year: string, lastYear: boolean, orgId?: number): Observable<any> {
    let url = this.urlWithOrgId(`/solution/calendar/accounting-info?orgId=`, orgId);
    url += `&year=${year}&lastYear=${lastYear}`;
    return this.http.get<any>(url);
  }



  getValidFrequencies(calendarType: CalendarType, year: string, orgId?: number): Observable<any> {
    let url = this.urlWithOrgId(`/solution/calendars/frequencies/info?orgId=`, orgId);
    url += `&year=${year}&subtype=${calendarType}`;
    return this.http.get<any>(url);
  }

  saveCalendarByType(calendar: CalendarEvent, orgId?: number): Observable<QueryResult> {
    let url = this.urlWithOrgId(`/solution/calendars?orgId=`, orgId);

    url += this.convertToCalendarParam(calendar);
    if (calendar.id) {
      return this.http.put<QueryResult>(url, calendar);
    } else {
      return this.http.post<QueryResult>(url, {});
    }
  }

  deleteCalendarByType(calendarType: CalendarType, year: string, orgId?: number): Observable<any> {
    let url = this.urlWithOrgId(`/solution/calendars?subtype=${calendarType}&year=${year}&orgId=`, orgId);
    return this.http.delete<any>(url);
  }

  saveCalendarEvent(calendar: CalendarEvent, orgId?: number): Observable<any> {
    let url: string;

    if (calendar.id) {
      url = this.urlWithOrgId(`/solution/calendar/${calendar.id}?orgId=`, orgId);
      return this.http.put<CalendarEvent>(url, calendar);
    } else {
      url = this.urlWithOrgId(`/solution/calendar?orgId=`, orgId);
      return this.http.post<CalendarEvent>(url, calendar);
    }
  }

  deleteCalendarEvent(calendarId: number, orgId?: number): Observable<any> {
    let url = this.urlWithOrgId(`/solution/calendars/${calendarId}?orgId=`, orgId);
    return this.http.delete<any>(url);
  }

  copyDefaultHolidayCalendar(year: string, orgId?: number): Observable<QueryResult> {
    let url = this.urlWithOrgId(`/solution/holiday-calendars?year=${year}&orgId=`, orgId);
    return this.http.post<QueryResult>(url, {});
  }
}
